// Callers provide complete /api paths; tolerate older bases ending in /api.
const API_URL = (import.meta.env.VITE_API_URL ?? '').replace(/\/+$/, '').replace(/\/api$/, '');
let getToken: () => string | undefined = () => undefined;
export const configureApiToken = (fn: () => string | undefined) => { getToken = fn; };

export class ApiClientError extends Error { constructor(public status: number, public code: string, message: string) { super(message); } }
export async function api<T>(path: string, options: RequestInit & { revision?: number; idempotencyKey?: string } = {}): Promise<T> {
  const token = getToken();
  const headers = new Headers(options.headers);
  headers.set('accept', 'application/json');
  if (options.body) headers.set('content-type', 'application/json');
  if (token) headers.set('authorization', `Bearer ${token}`);
  if (options.revision) headers.set('if-match', String(options.revision));
  if (options.idempotencyKey) headers.set('idempotency-key', options.idempotencyKey);
  const response = await fetch(`${API_URL}${path}`, { ...options, headers });
  if (!response.ok) {
    const body = await response.json().catch(() => ({ error: { code: 'HTTP_ERROR', message: response.statusText } })) as { error: { code: string; message: string } };
    throw new ApiClientError(response.status, body.error.code, body.error.message);
  }
  if (response.status === 204) return undefined as T;
  return response.json() as Promise<T>;
}
